// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"544d020d","368":"ad7937f2","420":"428817d5","539":"00d05dbb","541":"93ced5a1","644":"e284f866","857":"888d35e9","884":"9645bcaf","945":"5b181975"}[chunkId] + ".js";
};